<template>
  <div class="dashboard">
    <dashboard-pane />
    <dimmed v-if="(planData.hasPlan && isShowNoCredit && !hasCredit)">
      <dashboard-no-credit v-if="(planData.hasPlan && isShowNoCredit && !hasCredit)"
                           @onClose="isShowNoCredit = false" />
    </dimmed>
  </div>
</template>

<script>
import { CommonStorage } from '@/libs/auth-helper'
import { mapState } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import { getNotice } from '@/api/notice'
import { getI18n } from '@/libs/i18n'
import Dimmed from '@/components/ui/Dimmed'
import DashboardNoCredit from '@/components/dashboard/DashboardNoCredit'
import DashboardPane from '@/components/dashboard/DashboardPane.v2'
import { create } from 'vue-modal-dialogs'
import NoticePopup from '@/components/ui/NoticePopup'

const openNotice = create(NoticePopup)

export default {
  name: 'Dashboard',
  components: {
    Dimmed,
    DashboardPane,
    DashboardNoCredit
  },
  created () {
    EventBus.$emit('setTitle', null)
    EventBus.$emit('onLoading', false)
    this.loadNotice()
  },
  mounted () {
    window.addEventListener('message', function (msg) {
      if (msg.data) {
        const call = msg.data.call
        const model = msg.data.model
        if (model && model.content && call && call === 'popupPreview') {
          const content = model.content
          const serviceType = model.serviceType
          const location = model.exposureLocation
          if (content && serviceType && location && serviceType === 'ba' && location === 'dashboard') {
            const popupPreviewContainer = document.querySelector('#app > div:nth-child(2)')
            if (popupPreviewContainer) {
              popupPreviewContainer.innerHTML = ''
              const popupId = document.createElement('div')
              popupId.id = 'ba-notice'
              popupId.className = 'notice_dialog'
              popupId.innerHTML = content
              popupPreviewContainer.append(popupId)
            }
          }
        }
      }
    })
  },
  methods: {
    loadNotice () {
      const noticeParam = {
        exposureLocation: 'dashboard',
        lang: getI18n().locale,
        serviceType: 'ba'
      }
      getNotice(noticeParam).then((data) => {
        if (data.length > 0) {
          const noticeList = data.sort((a, b) => {
            return a.priority > b.priority ? -1 : 1
          })
          noticeList.forEach((item) => {
            const popupId = item._id
            if (popupId) {
              const cookie = CommonStorage.getItem('baNotice' + item._id)
              if (!cookie) {
                openNotice({ data: item }).then((response) => {
                })
              }
            }
          })
        }
      }).catch(noticeErr => {
      })
    }
  },
  computed: {
    ...mapState([
      'userData',
      'planData'
    ]),
    hasCredit () {
      return !this.userData.userCreditEmpty && this.userData.remainPv > 0
    }
  },
  data () {
    return {
      isShowNoCredit: true
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  max-width: 1920px;
  padding: 0 54px;
}
</style>
